"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPinPositionMap = buildPinPositionMap;
exports.claimPinsForPhysicalPart = claimPinsForPhysicalPart;
exports.physicalPartEmitsPins = physicalPartEmitsPins;
exports.enumerateGenuineSections = enumerateGenuineSections;
const orcadPinRefs_1 = require("./orcadPinRefs");
function buildPinPositionMap(physicalPart) {
    const pinPositionMap = new Map();
    for (const pinNumber of physicalPart.PinNumber ?? []) {
        if (pinPositionMap.has(pinNumber.Position)) {
            throw new Error(`Duplicate pin position ${pinNumber.Position} found in physical part`);
        }
        const number = pinNumber.Number.toString();
        if (number === '') {
            throw new Error(`Empty pin number at position ${pinNumber.Position} in physical part`);
        }
        pinPositionMap.set(pinNumber.Position, number);
    }
    return pinPositionMap;
}
function claimPinsForPhysicalPart(libPart, pinPositionMap, pinRefByPosition, emittedPinNumbersByView) {
    const claimedByView = new Map();
    for (const normalView of libPart.NormalView ?? []) {
        let emittedPinNumbers = emittedPinNumbersByView.get(normalView.Suffix);
        if (!emittedPinNumbers) {
            emittedPinNumbers = new Set();
            emittedPinNumbersByView.set(normalView.Suffix, emittedPinNumbers);
        }
        const claimed = new Set();
        for (const p of [...(normalView.PinScalar ?? []), ...(normalView.PinBus ?? [])]) {
            const pinNumber = pinPositionMap.get(p.Position);
            if (pinNumber === undefined) {
                throw new Error(`Pin position ${p.Position} not found in pin position map`);
            }
            const pinRef = pinRefByPosition.get(p.Position) ?? pinNumber;
            if (emittedPinNumbers.has(pinRef)) {
                continue;
            }
            emittedPinNumbers.add(pinRef);
            claimed.add(pinRef);
        }
        claimedByView.set(normalView.Suffix, claimed);
    }
    return claimedByView;
}
function physicalPartEmitsPins(libPart, physicalPart, emittedPinNumbersByView) {
    const pinPositionMap = buildPinPositionMap(physicalPart);
    const pinRefByPosition = (0, orcadPinRefs_1.buildPinRefByPosition)(pinPositionMap);
    const claimed = claimPinsForPhysicalPart(libPart, pinPositionMap, pinRefByPosition, emittedPinNumbersByView);
    return Array.from(claimed.values()).some((pinRefs) => pinRefs.size > 0);
}
function enumerateGenuineSections(libPartsInEmissionOrder, claimScope) {
    const sections = [];
    const sharedClaims = new Map();
    for (const libPart of libPartsInEmissionOrder) {
        const claims = claimScope === 'perLibPart' ? new Map() : sharedClaims;
        for (const physicalPart of libPart.PhysicalPart ?? []) {
            if (physicalPartEmitsPins(libPart, physicalPart, claims)) {
                sections.push({ libPart, physicalPart });
            }
        }
    }
    return sections;
}
//# sourceMappingURL=OrcadDsnSectionEmission.js.map